import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { apiBaseUrl } from 'api';
import { Menu, MenuItem, Typography, ListItemIcon, Link as LinkMaterial } from '@material-ui/core';
import {
  AttachmentOutlined as AttachmentIconOutlined,
  CloudDownloadOutlined as CloudDownloadIconOutlined,
  CloudUploadOutlined as CloudUploadOutlinedIcon,
  EditOutlined as EditIconOutlined,
  VisibilityOutlined as VisibilityIconOutlined,
  SendOutlined,
  Edit,
  ListAltOutlined,
} from '@material-ui/icons/';
import {
  PAYMENT_CREDIT_CARD,
} from 'constants/sales';
import { SaleDashboardContext } from 'contexts/saleDashboard';
import { UserContext } from 'contexts/user';
import { connect } from 'react-redux';
import { create as apiCreate } from 'api';
import { showNotification } from 'store/actions/notifications';
import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'constants/notification';
import { isPlanoAnalise } from 'helpers/process.helper';
import { useStyles } from '../style';

function OpenMenus({ notify }) {
  const classes = useStyles(false);
  const dashContext = useContext(SaleDashboardContext);
  const { userCoordinator } = useContext(UserContext);
  const { menuEl, currentClient } = dashContext;

  // Plano Análise (fase 4): cria a venda de continuação (Plano 2026) já
  // com requerentes, processos e o abatimento do valor da análise, e abre
  // a venda nova. A api só aceita depois do laudo emitido.
  const criarContinuacao = () => {
    dashContext.openMenu(false, 0);
    apiCreate(`salesscope/${currentClient.id}/continuacao-analise`, {})
      .then((res) => {
        const abatimento = res.abatimento ? ` Abatimento da análise: R$ ${(res.abatimento / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}.` : '';
        notify(NOTIFICATION_TYPE_SUCCESS, `Venda de continuação ${res.scope.client_id} criada.${abatimento}`);
        window.open(`/nova-venda/${res.scope.id}`, '_blank');
      })
      .catch((err) => {
        notify(NOTIFICATION_TYPE_ERROR, err?.response?.data?.message || 'Não foi possível criar a continuação.');
      });
  };

  const paymentsLength = currentClient.payments
    ? currentClient.payments.filter((a) => a.payment_method !== PAYMENT_CREDIT_CARD).length : 0;

  return (
    <div>
      <Menu
        id="scopeMenu"
        anchorEl={menuEl.scope}
        keepMounted
        open={Boolean(menuEl.scope)}
        onClose={
          () => dashContext.openMenu(false, 0)
        }
        elevation={2}
      >
        <Link
          className={classes.link}
          to={`/nova-venda/${currentClient.id}`}
          target="_blank"
          onClick={
            () => dashContext.openMenu(false, 0)
          }
        >
          <MenuItem>
            <ListItemIcon className={classes.popMenuIcon}>
              {currentClient.salesStep < 1 ? <EditIconOutlined /> : <VisibilityIconOutlined />}
            </ListItemIcon>
            <Typography color="textPrimary">{`${currentClient.salesStep < 1 ? 'Editar' : 'Ver'} escopo`}</Typography>
          </MenuItem>
        </Link>
        {isPlanoAnalise(currentClient.family_plan) && (
          <MenuItem onClick={criarContinuacao}>
            <ListItemIcon className={classes.popMenuIcon}>
              <ListAltOutlined />
            </ListItemIcon>
            <Typography color="textPrimary">Criar continuação (Plano 2026 com abatimento)</Typography>
          </MenuItem>
        )}
      </Menu>
      <Menu
        id="contractMenu"
        anchorEl={menuEl.contract}
        keepMounted
        open={Boolean(menuEl.contract)}
        onClose={
          () => dashContext.openMenu(false, 1)
        }
        elevation={2}
      >
        <Link
          className={classes.link}
          to={`/contrato/${currentClient.id}`}
          target="_blank"
          onClick={
            () => dashContext.openMenu(false, 1)
          }
        >
          <MenuItem>
            <ListItemIcon className={classes.popMenuIcon}>
              <VisibilityIconOutlined />
            </ListItemIcon>
            <Typography color="textPrimary">Ver contrato</Typography>
          </MenuItem>
        </Link>
        {currentClient.contract_path && (
          <MenuItem onClick={() => dashContext.handleSendContractEmail(currentClient)}>
            <ListItemIcon className={classes.popMenuIcon}>
              <SendOutlined />
            </ListItemIcon>
            <Typography color="textPrimary">
              {'Reenviar e-mail de contrato'}
            </Typography>
          </MenuItem>
        )}
        {!userCoordinator && !currentClient.id
          ? null
          : (
            <MenuItem
              onClick={() => {
                dashContext.handleDialogEditContract();
                dashContext.openMenu(false, 1);
              }}
            >
              <ListItemIcon className={classes.popMenuIcon}>
                <Edit />
              </ListItemIcon>
              <Typography color="textPrimary">
                {'Editar contrato'}
              </Typography>
            </MenuItem>
          )}
        {currentClient.contract_path && (
          <LinkMaterial
            className={classes.link}
            href={`${apiBaseUrl}/contracts/${currentClient.contract_path}`}
            target="_blank"
            onClick={
              () => dashContext.openMenu(false, 1)
            }
          >
            <MenuItem>
              <ListItemIcon className={classes.popMenuIcon}>
                <CloudDownloadIconOutlined />
              </ListItemIcon>
              <Typography>
                {'Baixar contrato para impressão'}
              </Typography>
            </MenuItem>
          </LinkMaterial>

        )}
        {currentClient.signed_contract_path && (
          <LinkMaterial
            className={classes.link}
            href={`${apiBaseUrl}/contracts/${currentClient.signed_contract_path}`}
            target="_blank"
            onClick={
              () => dashContext.openMenu(false, 1)
            }
          >
            <MenuItem>
              <ListItemIcon className={classes.popMenuIcon}>
                <CloudDownloadIconOutlined />
              </ListItemIcon>
              <Typography>
                {'Baixar contrato assinado para impressão'}
              </Typography>
            </MenuItem>
          </LinkMaterial>

        )}
        <MenuItem
          onClick={() => {
            dashContext.handleDialogSignedContract(currentClient);
            dashContext.openMenu(false, 1);
          }}
        >
          <ListItemIcon className={classes.popMenuIcon}><CloudUploadOutlinedIcon /></ListItemIcon>
          <Typography>{`${currentClient.signed_contract_path ? 'Reenviar' : 'Enviar'} contrato assinado`}</Typography>
        </MenuItem>
      </Menu>
      <Menu
        id="paymentMenu"
        anchorEl={menuEl.payment}
        keepMounted
        open={Boolean(menuEl.payment)}
        onClose={
          () => dashContext.openMenu(false, 2)
        }
        elevation={2}
      >
        {paymentsLength > 0
          ? ([
            <MenuItem
              key="anexar-comprovante"
              onClick={() => {
                dashContext.openMenu(false, 2);
                dashContext.handleDialogPayment(currentClient);
              }}
            >
              <ListItemIcon className={classes.popMenuIcon}>
                <AttachmentIconOutlined />
              </ListItemIcon>
              <Typography>Anexar comprovante</Typography>
            </MenuItem>,
            <MenuItem
              key="ver-pagamentos"
              onClick={() => {
                dashContext.openMenu(false, 2);
                dashContext.handleDialogPaymentsStatus(currentClient);
              }}
            >
              <ListItemIcon className={classes.popMenuIcon}>
                <ListAltOutlined />
              </ListItemIcon>
              <Typography>Ver pagamentos</Typography>
            </MenuItem>,
          ]) : (
            <Typography
              color="textSecondary"
              style={{
                padding: '0 8px',
                userSelect: 'none',
                outline: 'none',
              }}
            >
              {'Aguarando o pagamento'}
            </Typography>
          )}
      </Menu>
    </div>
  );
}

export default connect(null, { notify: showNotification })(OpenMenus);
